import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ParticleNetwork from '../components/ParticleNetwork';
import '../styles/ReferencesPage.css';

const ReferencesPage = () => {
  const { t } = useTranslation();

  const referenceLogos = [
    { name: 'KUS GRUP', logo: '/images/1-1.png' },
    { name: 'TOC', logo: '/images/toc-logo.png' },
    { name: 'Marmara Teknik Makine', logo: '/images/3-1.png' },
    { name: 'Gebze Palet', logo: '/images/2-1.png' },
    { name: 'KUS GRUP Yatay', logo: '/images/kusgrupyatay.png' },
    { name: 'Marmara', logo: '/images/marmarayatay.png' },
    { name: 'Gebze Palet Yatay', logo: '/images/gebzepaletyatay.png' },
    { name: 'Yerli Üretim', logo: '/images/Yerli_üretim_logosu.svg' }
  ];

  return (
    <div className="references-page">
      <section className="references-hero">
        <ParticleNetwork />
        <div className="container">
          <motion.div
            className="hero-centered-content"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="breadcrumbs">
              <Link to="/">{t('nav.home')}</Link>
              <span className="separator">/</span>
              <span className="current">{t('nav.references')}</span>
            </div>
            <h1 className="hero-title">{t('nav.references')}</h1>
            <div className="hero-accent-line"></div>
          </motion.div>
        </div>
      </section>

      <section className="references-content">
        <div className="container">
          <div className="reference-logo-grid">
            {referenceLogos.map((reference, index) => (
              <motion.article
                className="reference-logo-card"
                key={reference.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.06 }}
                whileHover={{ y: -6 }}
              >
                <img src={reference.logo} alt={`${reference.name} Logo`} />
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReferencesPage;
